<app-rback rurl="/life"></app-rback>
<app-xtheme>
  <app-xtheme-hh>
    <div class="logoname life-theme-color">{{ttitle}}</div>
   
    <div class="map-model-group" (click)="showFullMapEvent()">
      <img class="mmg-icon" src="/assets/imgs/icon/imap.png"/> 
      <div class="txt life-theme-color">地图模式</div>
    </div>

    <div class="map-group">
      <div class="mg-container" (click)="showFullMapEvent()">
        <app-hzoom>
          <img class="oimg" *ngIf="iconSeled===-1" src="/assets/imgs/main/main-map.png" />
          <img class="iled" *ngIf="iconSeled>-1" src="/assets/imgs/gif/13_zjwpzy_{{iconSeled}}.gif" />
        </app-hzoom>
      </div> 
    </div> 

    <div class="btns-group">
      <app-liked-shared [mapkey]="'zjwpzy'"></app-liked-shared>
      
      <div class="bbitem" *ngFor="let item of icons; let i = index" (click)="iconSeledEvent(i)" > 
        <img class="icon" src="/assets/imgs/icon/zjwpzy-{{item.id + (iconSeled === i ? 'ed' : '')}}.png" />
      </div>
    </div>
    <div class="list-group">
      <div class="title-group life-theme-color">
        <ng-container *ngIf="iconSeled==0">
          <div class="title-group2">
            <div class="tg2-label {{cxi==iconSeled2?'':'noactive'}}" *ngFor="let citem of icons[iconSeled].childs;let cxi=index" (click)="iconSeled2Event(cxi)">{{citem}}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="iconSeled==1">
          {{icons[iconSeled].name}}
        </ng-container>
      </div>
      <div class="lg-group">
        <div class="lggitem" *ngIf="iconSeled2==1">
          <div class="school life-theme-color">申报单位</div>
          <div class="subjects"> 
            <div class="subitem life-theme-color">专业群名称</div> 
          </div>
        </div>
        <div class="lggitem" *ngFor="let item of data;let i = index" (click)="showFullMapEvent(item.id)">
          <div class="school {{iconSeled2==0?'fullwidth':''}}">{{ i+1 + '、' + item.name}}</div>
          <div class="subjects" *ngIf="iconSeled2!=0"> 
            <div class="subitem" *ngFor="let subject of item.majors">{{subject}}</div> 
          </div>
        </div>
      </div>
      <div class="copytime">数据更新时间：2022年8月</div>
    </div>
  </app-xtheme-hh>
  <app-xtheme-vv>
    <div class="left-wrapper">
      <div class="map-model-group" (click)="showFullMapEvent()">
        <img class="mmg-icon" src="/assets/imgs/icon/imap.png"/> 
        <div class="txt life-theme-color">地图模式</div>
      </div>
 
      <div class="map-group">
        <div class="mg-container" (click)="showFullMapEvent()">
          <app-zoomer>
            <img class="oimg" *ngIf="iconSeled===-1" src="/assets/imgs/main/main-map.png" />
            <img class="iled" *ngIf="iconSeled>-1" src="/assets/imgs/gif/13_zjwpzy_{{iconSeled}}.gif" />
          </app-zoomer>
        </div> 
      </div>
    </div>
    <div class="right-wrapper">
      <div class="logoname life-theme-color">{{ttitle}}</div>

      <div class="btns-wrapper">
        <div class="btns-group">
          <div class="bbitem" *ngFor="let item of icons; let i = index" (click)="iconSeledEvent(i)">  
            <img class="icon" src="/assets/imgs/icon/zjwpzy-{{item.id + (iconSeled === i ? 'ed' : '')}}.png" />
          </div> 
        </div>
      </div>
      <div class="list-group">
        <div class="title-group life-theme-color">
          <ng-container *ngIf="iconSeled==0">
            <div class="title-group2">
              <div class="tg2-label {{cxi==iconSeled2?'':'noactive'}}" *ngFor="let citem of icons[iconSeled].childs;let cxi=index" (click)="iconSeled2Event(cxi)">{{citem}}</div>
            </div>
          </ng-container>
          <ng-container *ngIf="iconSeled==1">
            {{icons[iconSeled].name}}
          </ng-container>
        </div>
        <div class="lg-group">
          <div class="lggitem" *ngIf="iconSeled2==1">
            <div class="school life-theme-color">申报单位</div>
            <div class="subjects"> 
              <div class="subitem life-theme-color">专业群名称</div> 
            </div>
          </div>
          <div class="lggitem" *ngFor="let item of data;let i = index" (click)="showFullMapEvent(item.id)">
            <div class="school {{iconSeled2==0?'fullwidth':''}}">{{ i+1 + '、' + item.name}}</div>
            <div class="subjects" *ngIf="iconSeled2!=0"> 
              <div class="subitem" *ngFor="let subject of item.majors">{{subject}}</div> 
            </div>
          </div>
        </div>
         
        <div class="copytime">数据更新时间：2022年8月</div>
      </div>
    </div>
  </app-xtheme-vv>
</app-xtheme>
   